import sitesRouter from './sitesRouter';

export default sitesRouter;
